import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import { useDriverNotes, useHQCompanies } from "../../hooks/queries";
import { supabase } from "../../supabaseClient";
import {
  useCreateDriverNote,
  useCreateHQCompany,
  useUpdateDriverNote,
  useUpdateHQCompany,
} from "../../hooks/mutation";
import { toast } from "react-toastify";
import { FaAngleLeft, FaAngleRight, FaEdit } from "react-icons/fa";
import { PAGE_SIZE } from "../Utils/constant";

const HQCompanyNew = () => {
  const [page, setPage] = useState(1);

  const [isEdit, setIsEdit] = useState(false);
  const [HQCompany, setHQCompany] = useState(null);
  const [search, setSearch] = useState(null);
  const { data } = useHQCompanies(isEdit, search, page);
  const [HQCompaniesData, setHQCompaniesData] = useState();
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    if (data) {
      setHQCompaniesData(data.data);
      setTotalCount(data.count);
    }
  }, [data]);

  const [companies, setCompanies] = useState([]);
  const [HQs, setHQs] = useState([]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      companyID: "",
      HQID: "",
    },
  });

  useEffect(() => {
    const fetchHQCompanies = async () => {
      const { data: Companies, error: cError } = await supabase
        .from("Companies")
        .select("CompanyID, Name");

      const { data: HQs, error: hError } = await supabase
        .from("HQs")
        .select("HQID, Code");

      if (cError) {
        setCompanies([]);
      } else if (hError) {
        setHQs([]);
      } else {
        setCompanies(Companies);
        setHQs(HQs);
        if (Companies.length > 0) {
          reset({
            companyID: Companies[0].companyID,
            HQID: HQs[0].HQID,
          });
        }
      }
    };
    fetchHQCompanies();
  }, [reset]);

  useEffect(() => {
    if (HQCompany) {
      reset({
        CompanyID: HQCompany.Company.CompanyID,
        HQID: HQCompany.HQ.HQID,
      });
    }
  }, [HQCompany, reset]);

  const onNextPage = useCallback(() => {
    setPage((old) => old + 1);
  }, []);
  const onPrevPage = useCallback(() => {
    console.log(page);
    setPage((old) => old - 1);
  }, []);

  const onSuccess = useCallback((_data) => {
    toast.success("Success");
  }, []);
  const onError = useCallback(
    (err) => {
      console.log("error", err);
      reset();
    },
    [reset]
  );

  const onAddNew = () => {
    setIsEdit(true);
    reset({
      companyID: companies[0] ? companies[0].companyID : "",
      HQID: HQs[0] ? HQs[0].HQID : "",
    });
  };

  const OnCancel = () => {
    setIsEdit(false);
    setHQCompany();
  };

  const { mutate: createHQCompany, isPending: isCreating } = useCreateHQCompany(
    onSuccess,
    onError
  );

  const { mutate: updateHQCompany, isPending: isUpdating } = useUpdateHQCompany(
    onSuccess,
    onError
  );

  const OnCreate = useCallback(
    (data) => {
      if (HQCompany) {
        updateHQCompany({ ...data, ID: HQCompany.HQCompanyID });
      } else {
        createHQCompany(data);
      }
    },
    [HQCompany, createHQCompany, updateHQCompany]
  );
  const OnSearch = useCallback(
    (data) => {
      setSearch(data);
    },
    [setSearch]
  );

  return (
    <>
      {isEdit ? (
        <div className="driver-patent-edit-content mt-4 rounded-lg">
          <div className="flex justify-between mb-2">
            <div>HQ</div>
            <div className="w-35">
              <Controller
                control={control}
                name="HQID"
                rules={{
                  required: "Required",
                }}
                render={({ field: { value, onChange } }) => (
                  <select
                    className="custom-input rounded-lg"
                    value={value}
                    onChange={onChange}
                    error={errors.HQID?.message}
                  >
                    {HQs.map((HQ) => (
                      <option key={HQ.HQID} value={HQ.HQID}>
                        {HQ.Code}
                      </option>
                    ))}
                  </select>
                )}
              />
            </div>
          </div>
          <div className="flex justify-between mb-2">
            <div>Company</div>
            <div className="w-35">
              <Controller
                control={control}
                name="CompanyID"
                rules={{
                  required: "Required",
                }}
                render={({ field: { value, onChange } }) => (
                  <select
                    className="custom-input rounded-lg"
                    value={value}
                    onChange={onChange}
                    error={errors.CompanyID?.message}
                  >
                    {companies.map((company) => (
                      <option key={company.CompanyID} value={company.CompanyID}>
                        {company.Name}
                      </option>
                    ))}
                  </select>
                )}
              />
            </div>
          </div>
          <div className="flex gap-4 mt-4 save-button">
            <button
              disabled={isCreating | isUpdating}
              onClick={handleSubmit(OnCreate)}
              className="justify-between p-2 pr-20 pl-20 rounded-lg mr-1 flex items-center custom-blue-button"
            >
              <span>{HQCompany ? "Update" : "Create"}</span>
            </button>
            <div>
              <div
                onClick={OnCancel}
                className="justify-between pl-20 pr-20 p-2 rounded-lg flex items-center custom-white-button"
              >
                <span>Cancel</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex ">
            <h5 className="mb-0">Driver Notes</h5>
            <button
              className="justify-between rounded-lg ml-1 flex items-center custom-blue-button border-none"
              onClick={onAddNew}
            >
              <span>Add New</span>
            </button>
          </div>
          <SearchBar setSearch={setSearch} OnSearch={OnSearch} />

          <table className="table-auto w-full mt-4 border border-gray-200">
            <thead>
              <tr className="bg-gray-100 cursor-pointer">
                <th className="px-4 py-2 border">ID</th>
                <th className="px-4 py-2 border">HQ Code</th>
                <th className="px-4 py-2 border">Company Name</th>
                <th className="px-4 py-2 border">Edit</th>
              </tr>
            </thead>
            <tbody>
              {HQCompaniesData &&
                HQCompaniesData.map((HQCompany) => (
                  <tr key={HQCompany.HQCompanyID} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">
                      {HQCompany.HQCompanyID}
                    </td>
                    <td className="px-4 py-2 border">{HQCompany.HQ.Code}</td>
                    <td className="px-4 py-2 border">
                      {HQCompany.Company.Name}
                    </td>
                    <td className="px-4 py-2 border cursor-point">
                      <FaEdit
                        onClick={() => {
                          setHQCompany(HQCompany);
                          setIsEdit(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="pagination-container">
            <div className="pagination-content">
              <div>
                <p className="pagination-text">
                  Showing <span>{(page - 1) * PAGE_SIZE + 1}</span> to{" "}
                  <span>{Math.min(totalCount, page * PAGE_SIZE)}</span> of{" "}
                  <span>{totalCount}</span> results
                </p>
              </div>
              <div>
                <nav className="pagination-nav">
                  <button
                    onClick={onPrevPage}
                    disabled={page == 1}
                    className={`pagination-item ${page == 1 ? "disabled" : ""}`}
                  >
                    <FaAngleLeft className="pagination-icon" />
                  </button>
                  <button
                    onClick={onNextPage}
                    disabled={page * PAGE_SIZE > totalCount}
                    className={`pagination-item ${
                      page * PAGE_SIZE > totalCount ? "disabled" : ""
                    }`}
                  >
                    <FaAngleRight className="pagination-icon" />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HQCompanyNew;

const SearchBar = ({ setSearch, OnSearch }) => {
  const {
    control: searchControl,
    handleSubmit: handleSearchSubmit,
    reset: searchReset,
  } = useForm({
    defaultValues: {
      type: "ID",
      which: "contains",
      text: "",
    },
  });

  return (
    <div className="flex mt-4 items-center">
      <div>
        <p className="mb-0">Look For:</p>
      </div>
      <div className="flex justify-between w-10 ml-1">
        <Controller
          control={searchControl}
          name="type"
          render={({ field: { value, onChange } }) => (
            <select
              className="custom-input rounded-lg cursor-pointer"
              value={value}
              onChange={onChange}
            >
              <option value={"HQCompanyID"}>HQCompany ID</option>
              <option value={"Code"}>HQ Code</option>
              <option value={"Name"}>Company Name</option>
            </select>
          )}
        />
      </div>

      <div className="ml-1">
        <p className="mb-0">Which:</p>
      </div>
      <div className="flex justify-between w-10 ml-1">
        <Controller
          control={searchControl}
          name="which"
          render={({ field: { value, onChange } }) => (
            <select
              className="custom-input rounded-lg cursor-pointer"
              value={value}
              onChange={onChange}
            >
              <option value="contains">contains</option>
              <option value="starts with">starts with</option>
              <option value="equals">equals</option>
              <option value="ends with">ends with</option>
            </select>
          )}
        />
      </div>
      <div className="ml-1">
        <Controller
          control={searchControl}
          name="text"
          rules={{
            required: "Required",
          }}
          render={({ field: { value, onChange } }) => (
            <input
              type=""
              value={value}
              onChange={onChange}
              className="custom-input rounded-lg w-100 "
            />
          )}
        />
      </div>
      <div className="ml-1 flex">
        <div>
          <button
            onClick={handleSearchSubmit(OnSearch)}
            className="justify-between rounded-lg flex items-center w-30 custom-search-button border-none"
          >
            <span>Search</span>
          </button>
        </div>
        <div>
          <button
            onClick={() => {
              searchReset({
                type: "ID",
                which: "contains",
                text: "",
              });
              setSearch(null);
            }}
            className="justify-between rounded-lg ml-1 flex items-center custom-reset-button"
          >
            <span>Reset</span>
          </button>
        </div>
      </div>
    </div>
  );
};
